import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Typography, Button } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import Filter from 'src/components/Filter/Filter';
import { FilterList } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import loadPayments from 'src/store/actions/paymentsActions';
import { loadBillingFailures } from 'src/store/actions/billingActions';
import AutomaticDebitCollectionStatus from 'src/utils/payments';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import FILTER_TYPES from 'src/utils/constants/filter';
import { Failures } from 'src/utils/constants/failures';
import useStyles from './styles';

const filters = [
  {
    title: 'COMMON.DATE',
    controlGroup: FILTER_TYPES.DATE,
    items: [
      {
        label: 'COMMON.DATE',
        value: 'date',
        view: ['year', 'month']
      }
    ]
  }
];

const getFilterOptions = (options = {}, currentTab) => {
  const momentDate = options?.date !== undefined && options?.date !== null 
    ? momentLocalTimezone(options.date)
    : momentLocalTimezone();
  
  if (currentTab === Failures.PAYMENT) {
    const startDate = momentDate.startOf('month').toDate();
    const endDate = momentDate.endOf('month').toDate();
    
    return {
      dueDateRange: {
        startDate,
        endDate
      }
    };
  } 
  
  return {
    year: momentDate.year(),
    month: momentDate.month() + 1 
  };
};

const Toolbar = ({ className, currentTab, ...rest }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterValues, setFilterValues] = useState({});

  const loadData = useCallback((filterOptions) => {
    if (currentTab === Failures.PAYMENT) {
      dispatch(
        loadPayments({
          ...filterOptions,
          status: AutomaticDebitCollectionStatus.FAILED_TO_BE_DEBITED,
          page: 0
        })
      );
    } else if (currentTab === Failures.BILLING) {
      dispatch(
        loadBillingFailures({
          ...filterOptions,
          page: 0
        })
      );
    }
  }, [dispatch, currentTab]);

  const handleClickFilter = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleCloseFilter = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleFilterChange = useCallback((event) => {
    setFilterValues(event || {});
    const filterOptions = getFilterOptions(event, currentTab);
    loadData(filterOptions);
  }, [currentTab, loadData]);

  useEffect(() => {
    setFilterValues({});
    const filterOptions = getFilterOptions({}, currentTab);
    loadData(filterOptions);
  }, [currentTab, loadData]);
  return (
    <Box className={clsx(classes.root, className)} {...rest}>
      <Breadcrumb />
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          alignSelf: 'flex-end'
        }}
      >
        <Typography
          style={{ fontWeight: '400' }}
          color="primary"
          variant="h1"
        >
          {t('NAVIGATION.FAILURES')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            className={clsx(
              classes.buttons,
              classes.outlined,
              classes.horizontalPadding
            )}
            color="primary"
            onClick={handleClickFilter}
            sx={{ alignSelf: 'flex-end', backgroundColor: 'green' }}
          >
            <FilterList className={classes.icon} />
            {t('COMMON.FILTER')}
          </Button>
          <Filter
            anchorEl={anchorEl}
            filterValues={filterValues}
            handleClose={handleCloseFilter}
            handleChange={handleFilterChange}
            filters={filters}
          />
        </Box>
      </Box>
    </Box>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  currentTab: PropTypes.string
};

export default Toolbar;
